export default "__VITE_ASSET__Dv8_DPfp__"